import { Observable } from 'rxjs';
import { Component } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss']
})
export class ImageViewComponent extends AbstractWidgetComponent {

  urlImage: string;

  constructor(private httpService: HttpService) {
    super();
  }

  onContextChange(contextChange: ContextChange) {

  }


  onSetElementAndContext() {
    console.log('onSetElementAndContext');
    this.loadOverview();
  }

  private getYardMap(mapName: string): Observable<any> {
    return this.httpService.postWithContext(environment.yardMapEndpoint, mapName);
  }

  private loadOverview() {
    if (this.widgetReference != null && this.widgetReference.data.resourceUUID != null) {
      this.urlImage = environment.resourceEndpoint + '/archive/' + this.widgetReference.data.resourceUUID;
    }
  }
}
